import { defineStore } from "pinia";
import { useAssignmentsComposable } from "./assignments";
import { useSubmissionsComposable } from "./submissions";

export const useAssignmentsStore = defineStore("assignments", () => {
  const submissions = useSubmissionsComposable();
  const assignments = useAssignmentsComposable({
    loadSubmissions: submissions.loadSubmissions,
    submissionsForAssignmentMap: submissions.submissionsForAssignmentMap
  });

  return {
    ...assignments,
    ...submissions
  };
});
